import { requestGet, requestPost, requestPatch, requestDelete } from "./ajax"

export const ajaxTest = ({ email, password, username }) => {
    return requestPost("auth/login", { email, password, username }, null)
}

export const userLogin = ({ email, password, username }) => {
    return requestPost("auth/login", { email, password, username }, null)
}

export const userResetPasswordRequest = ({ email }) => {
    return requestPost("auth/reset-password-request", { email }, null)
}

export const userNewUserVerification = (verificationToken) => {
    return requestPost("auth/verify", null, { verificationToken })
}

export const userNewUserResendToken = ({ email }) => {
    return requestPost("auth/reverify", { email }, null)
}

export const createPasswordTokenFromVerifyToken = ({ email, verificationToken }) => {
    return requestPost("auth/createPasswordTokenFromVerifyToken", { email }, { verificationToken })
}

export const userNewPassword = ({ password, passwordToken }) => {
    return requestPost("auth/newpassword", { password }, { passwordToken })
}

export const userUpdate = (reqObj) => {
    return requestPatch(`users/${reqObj.userId}`, reqObj, null)
}

export const userRoles = (userId) => {
    return requestGet(`users/${userId}/roles`)
}

export const getCompanyByCompanyId = (companyId) => {
    return requestGet(`companies/${companyId}`)
}

export const productSubscribedLatestStatusByCompanyId = (companyId) => {
    return requestGet(`products/productsSubscribeStatus`, { companyId })
}

export const productDetail = (productId) => {
    return requestGet(`products/${productId}`)
}

export const projectsListRequestByUserId = (userId) => {
    return requestGet(`users/${userId}/projects`)
}

export const projectQuickStart = ({ project, sponsor, manager }) => {
    const { userId } = sponsor
    return requestPost(`users/${userId}/quickCreateProject`, { project, sponsor, manager }, null)
}

export const activateProjectRequest = ({ project, sponsor, userId }) => {
    const manager = {
        managerUserId: userId,
    }
    return requestPost(`users/${userId}/activateProject`, { project, sponsor, manager }, { timeout: 0 })
}

export const searchUserByEmail = ({ email, companyId }) => {
    return requestPost("search/user-email", { email, companyId })
}

export const searchAllUsersByCompany = (companyId) => {
    return requestPost("search/users", { companyId })
}

export const getReminderDetailRequest = () => {
    return requestGet("reminders")
}

export const createParticipant = (participantNewDetail) => {
    return requestPost("participants", participantNewDetail, { timeout: 0 }) // do not set timeout, use the server timeout
}

export const deleteParticipantByParticipantId = (participantId, projectId) => {
    return requestDelete(`participants/${participantId}`, { projectId })
}

export const getParticipantsByProjectId = (projectId) => {
    return requestGet(`projects/${projectId}/participants`)
}

export const getProjectByProjectId = (projectId) => {
    return requestGet(`projects/${projectId}`)
}

export const updateSingleProjectByProjectId = ({ projectId, newProject }) => {
    return requestPatch(`projects/${projectId}`, newProject, { timeout: 0 })
}

export const updateProjectArchiveByProjectId = ({ projectId, archiveStatus }) => {
    return requestPatch(`projects/${projectId}`, { archive: archiveStatus })
}

export const getProjectRolesByProjectId = (projectId) => {
    return requestGet(`projects/${projectId}/roles`)
}

export const getParticipantByProjectIdWithHaveRoleStatus = ({ projectId, haveRole }) => {
    return requestGet(`projects/${projectId}/participants`, { haveRole })
}

export const sendAssessmentReminderEmail = ({ participantId, projectId }) => {
    return requestPost(`participants/${participantId}/reminder-assessment-emails`, { participantId, projectId })
}

export const sendRoleSettingReminderEmail = ({ participantId, projectId }) => {
    return requestPost(`participants/${participantId}/reminder-role-setting-emails`, { participantId, projectId })
}

export const updateParticipant = (participantNewDetail) => {
    const { participantId } = participantNewDetail
    return requestPatch(`participants/${participantId}`, participantNewDetail)
}

export const getUsersByCompanyId = (companyId) => {
    return requestGet(`users`, { companyId })
}

export const getNoManagerRoleUsersByCompanyId = (companyId) => {
    return requestGet(`companies/${companyId}/no-manager`)
}

export const getManagerRoleUsersByCompanyId = (companyId) => {
    return requestGet(`companies/${companyId}/manager`)
}

export const assignManagerRoleToUser = (userId, createUserName) => {
    return requestPost(`users/${userId}/assign-manager`, { createUserName })
}

export const newUserAssignManagerRole = (companyId, newParticipant, createUserName) => {
    return requestPost(`users/new-user-assign-manager`, { companyId, participantDetail: newParticipant, createUserName })
}

export const getDepartments = (companyId) => {
    return requestGet(`departments`, { companyId })
}

export const createNewDepartment = ({ companyId, departments }) => {
    return requestPost(`departments`, { companyId, departments })
}

export const updateDepartment = ({ companyId, departmentId, departmentName }) => {
    return requestPatch(`departments`, { companyId, departmentId, departmentName })
}

export const deleteDepartment = (departmentId, companyId) => {
    return requestDelete(`departments/${departmentId}`, { companyId })
}

export const getDesignations = (companyId) => {
    return requestGet(`designations`, { companyId })
}

export const updateDesignation = ({ companyId, designationId, designationName }) => {
    return requestPatch(`designations`, { companyId, designationId, designationName })
}

export const sendReminder = (projectId) => {
    return requestPost(`projects/sendReminder`, { projectId }, { timeout: 0 })
}

export const toggleEmailReminders = (projectId, status) => {
    return requestPost(`projects/toggleEmailReminders`, { projectId, status })
}
